import clsx from "clsx";
import { fontAwesome } from "@/styles/fonts";

function AccordionArrow(props: { direction: "down" | "right" }) {
  const { direction } = props;
  const symbol = direction === "down" ? "\uf0d7" : "\uf0da";
  return (
    <span className={clsx(
      fontAwesome.className,
      "ml-auto",
      'text-[#e0e0e0]',
      'shrink-0',
      'pr-0 sm:pr-[20px]',
    )}>{symbol}</span>);
}

export default AccordionArrow;
